export default __webpack_public_path__ + "static/media/spock.17369843.svg";